
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'
import { copyToClip } from '~/utils/index'
import { parseTime } from '~/utils/validate.js'

export default {
    components: {
        TitleBox
    },
    computed: {
        ...mapGetters({})
    },
    data() {
        return {
            modelShow: false, // 口令弹窗
            inviterModelShow: false, // 被邀人弹窗
            inviterCode: '', // 被邀人邀约码
            inviteData: [], // 活动邀请人列表
            userTypeData: null, // 角色状态
            detailsData: null, // 详情信息
            passwordLinkData: null, //口令
            amountData: null, //分佣 金额
            totalCount: 0
        }
    },
    methods: {
        // 复制
        copyPayNum(val) {
            copyToClip(val, '复制成功')
        },
        // 获取用户角色信息
        getUserType() {
            let data = {
                page: 'acb'
            }
            this.$api.inviteeUserType(data).then((res) => {
                if (res.success) {
                    this.userTypeData = res.data
                    if (this.userTypeData.inviter?.bindTime) {
                        this.userTypeData.inviter.bindTime = parseTime(this.userTypeData.inviter.bindTime, '{y}-{m}-{d}')
                    }
                    if (res.data.acType == 'inviter') {
                        // 获取邀请人数据
                        this.getInviteeList()
                        this.getAmount()
                    }
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 详情信息
        getDetails() {
            this.$api.acbDetails().then((res) => {
                if (res.success) {
                    this.detailsData = res.data
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 口令
        getPasswordLink() {
            this.$api.acbTemplateContent().then((res) => {
                if (res.success) {
                    const inviteCodePlaceholder = '$1' // 邀请码占位符
                    const shortLinkPlaceholder = '$2' // 短链接占位符
                    this.passwordLinkData = res.data.tplContent.replace(inviteCodePlaceholder, res.data.inviteCode).replace(shortLinkPlaceholder, res.data.shortLink)
                    this.modelShow = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 被邀人绑定
        getBind() {
            if (!this.inviterCode) {
                this.$message.error('请输入邀约码')
                return false
            }
            let data = {
                code: this.inviterCode
            }
            this.$api.acbInviteeBind(data).then((res) => {
                if (res.success) {
                    this.$message.success(res.info)
                    this.inviterModelShow = false
                    this.getUserType()
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 被邀人列表
        getInviteeList() {
            this.$api.acbInviteeList().then((res) => {
                if (res.success) {
                    this.inviteData = res.data.inviteeList
                    this.totalCount = res.data.totalCount
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 分佣金额
        getAmount() {
            this.$api.acbBrokerageAmount().then((res) => {
                if (res.success) {
                    this.amountData = res.data
                } else {
                    this.$message.error(res.info)
                }
            })
        }
    },
    mounted() {
        this.getDetails()
        this.getUserType()
    }
}
